import axios from "axios";

// const URL = "http://localhost:8000";
const URL = "https://beautifulgatetools-627aa69937b6.herokuapp.com";

const postApi = (
  Url,
  data = {},
  success = (f) => f,
  error = (f) => f,
  empty = (f) => f,
) => {
  const baseUrl = URL + Url;
  axios({
    method: "post",
    url: baseUrl,
    data: data,
  })
    .then((response) => {
      if (response) {
        success(response);
      } else {
        console.log("Empty response");
        empty();
      }
    })
    .catch((err) => {
      console.log(err, "error from helper");
      error(err);
    });
};

const uploadImageApi = (
  Url,
  data = {},
  success = (f) => f,
  error = (f) => f,
  empty = (f) => f,
  onUploadProgress = null,
) => {
  const baseUrl = URL + Url;

  axios({
    method: "post",
    url: baseUrl,
    data: data,
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: onUploadProgress,
  })
    .then((response) => {
      if (response) {
        success(response);
      } else {
        console.log("Empty response");
        empty();
      }
    })
    .catch((err) => {
      console.log(err, "error from helper");
      error(err);
    });
};

const getApi = (
  Url,
  success = (f) => f,
  error = (f) => f,
  empty = (f) => f,
) => {
  const baseUrl = URL + Url;
  axios
    .get(baseUrl)
    .then((response) => {
      if (response) {
        success(response);
      } else {
        console.log("Get successfull but empty");
        empty();
      }
    })
    .catch((err) => {
      error(err);
    });
};

const deleteItemAPI = (Url, data, success = (f) => f, error = (f) => f) => {
  const baseUrl = URL + Url;
  axios
    .delete(baseUrl, data)
    .then((response) => {
      if (response) {
        success(response);
      }
    })
    .catch((err) => {
      error(err);
    });
};

const updateItemAPI = (url, data, onSuccess, onError) => {
  const baseUrl = URL + url;
  fetch(baseUrl, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      // Add any authentication headers if needed
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      onSuccess(data);
    })
    .catch((error) => {
      onError(error);
    });
};

export { postApi, uploadImageApi, getApi, updateItemAPI, deleteItemAPI };
